export const EU_DEBIT_CARD_FEE = 0.68;
export const EU_CREDIT_CARD_FEE = 1.08;
export const NON_EU_AND_BUSINESS_CARD_FEE = 1.98;
